import React, { useState } from 'react';
import { MuiBox, InputField, Chip } from '@kis-technologies/kis-ui';
import { SouvenirEventIdsInputProps } from '../types';

const SouvenirEventIdsInput: React.FC<SouvenirEventIdsInputProps> = (props: SouvenirEventIdsInputProps) => {
  const { value, onChange, disabled = false } = props;

  const [inputValue, setInputValue] = useState('');

  const handleAdd = () => {
    const id = inputValue.trim();
    if (!id || value.includes(id)) {
      setInputValue('');
      return;
    }

    onChange([...value, id]);
    setInputValue('');
  };

  const handleRemove = (id: string) => {
    onChange(value.filter((v) => v !== id));
  };

  return (
    <MuiBox>
      <InputField
        size="small"
        placeholder="Enter event ID and press Enter"
        value={inputValue}
        disabled={disabled}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleAdd();
          }
        }}
        sx={{ width: { xs: '262px', sm: '524px' } }}
      />
      {value.length > 0 && (
        <MuiBox display="flex" flexWrap="wrap" gap="8px" mt="10px">
          {value.map((id) => (
            <Chip key={id} label={id} size="small" onDelete={disabled ? undefined : () => handleRemove(id)} />
          ))}
        </MuiBox>
      )}
    </MuiBox>
  );
};

export default SouvenirEventIdsInput;
